import { Dialog, Transition } from '@headlessui/react';
import React, {
createContext, useCallback, useContext, useRef, useState, Fragment } from
'react';

const DialogContext = createContext(null);
export const useOpenDialog = () => useContext(DialogContext);

export function DialogProvider({ children }) {
  const [props, setProps] = useState();

  const childRef = useRef(null);
  const componentRef = useRef(null);
  const promiseRef = useRef(null);

  const openPrompt = useCallback((component, componentProps) => {
    componentRef.current = component;
    return new Promise((resolve, reject) => {
      promiseRef.current = { resolve, reject };
      setProps(typeof componentProps === 'undefined' ? {} : componentProps);
    });
  }, []);

  const clear = () => {
    componentRef.current = null;
    promiseRef.current = null;
    setProps(null);
  };

  const onResolve = useCallback((reason) => {
    if (promiseRef.current) {
      promiseRef.current.resolve(reason);
    }
    clear();
  }, []);

  const onReject = useCallback((reason) => {
    if (promiseRef.current) {
      promiseRef.current.reject(reason);
    }
    clear();
  }, []);

  const Component = componentRef.current;

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(DialogContext.Provider, { value: openPrompt },
    children), /*#__PURE__*/


    React.createElement(Transition.Root, { show: !!componentRef.current, as: Fragment }, /*#__PURE__*/
    React.createElement(Dialog, {
      as: "div",
      className: "fixed z-10 inset-0 overflow-y-auto",
      onClose: onReject }, /*#__PURE__*/

    React.createElement("div", { className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }, /*#__PURE__*/
    React.createElement(Transition.Child, {
      as: Fragment,
      enter: "ease-out duration-300",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leave: "ease-in duration-200",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0" }, /*#__PURE__*/

    React.createElement(Dialog.Overlay, { className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })), /*#__PURE__*/



    React.createElement("span", { className: "hidden sm:inline-block sm:align-middle sm:h-screen", "aria-hidden": "true" }, "\u200B"), /*#__PURE__*/


    React.createElement(Transition.Child, {
      as: Fragment,
      enter: "ease-out duration-300",
      enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      enterTo: "opacity-100 translate-y-0 sm:scale-100",
      leave: "ease-in duration-200",
      leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
      leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" },

    Component ? /*#__PURE__*/
    React.createElement(Component, Object.assign({
      onResolve: onResolve,
      onReject: onReject,
      ref: childRef },
    props)) : /*#__PURE__*/

    React.createElement("div", null)))))));






}